import React, { FC, useMemo } from "react";
import { useSelector } from "react-redux";
import { ResourceTypeLink, ServiceListItemDc } from "@evergis/api";

import { QuickActionsBlock } from "../TopBar/styled";
import { AddToProject } from "./AddToProject";
import { DeleteResources } from "./DeleteResources";
import { CopyResources } from "./CopyResources";
import { ResetResources } from "./ResetResources";
import { SelectedInfo } from "./SelectedInfo";

import { useProjectInfo } from "../../../../ducks/project/hooks";
import { useResourceType } from "../../../../hooks/useResourceType";
import { ResourceCategory, useFetchParams } from "../../hooks/useFetchParams";
import { getSelected } from "../../../../ducks/catalog/selectors";
import { isEditableType } from "../../../../evergis/core/permissions";

export const SelectedResources: FC = () => {
  const [{ name, content }] = useProjectInfo();
  const selectedResources = useSelector(getSelected);
  const [resourceType] = useResourceType();
  const { category } = useFetchParams();
  const isLayer = resourceType === ResourceTypeLink.Layer;
  const isTable = resourceType === ResourceTypeLink.Table;
  const isUserResources = category === ResourceCategory.User;

  const isAbleToAddLayers = useMemo(
    () =>
      isLayer &&
      name !== undefined &&
      (!content.items ||
        !selectedResources.some(resource => content.items.some(layer => resource.name === layer.name))),
    [resourceType, name, content, selectedResources],
  );

  const isEditType =
    (isLayer && selectedResources.every(r => isEditableType((r as ServiceListItemDc).dataSourceType))) ||
    (isTable && selectedResources.every(r => isEditableType((r as ServiceListItemDc).type)));

  return (
    <QuickActionsBlock>
      <SelectedInfo type={resourceType} />
      {<CopyResources />}
      {isUserResources && isEditType && <DeleteResources />}
      {isAbleToAddLayers && <AddToProject />}
      <ResetResources />
    </QuickActionsBlock>
  );
};
